export default __webpack_public_path__ + "static/media/doctor.6d1eccc3.png";